import { AppBar, Tab, Tabs, Box, Typography } from "@material-ui/core";
import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useStyles } from "Theme/styles";
import ResponsiveTable from "./ResponsiveTable";

export interface ListAndAddTabsProps {
  listChildren: any;
  addChildren: any;
  fromEdit: boolean;
  value: number;
  handleChange: (newValue: any) => void;
}
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return (
    <div
      className={classes.paperContent}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ListAndAddTabs({
  listChildren,
  addChildren,
  fromEdit,
  value,
  handleChange,
}: ListAndAddTabsProps) {
  // const handleChange = (event: any, newValue: any) => {
  //   setValue(newValue);
  // };
  const classes = useStyles();
  return (
    <Fragment>
      <AppBar position="static" className={classes.appBarTabs}>
        <Tabs
          value={value}
          onChange={(event: any, newValue: any) => {
            handleChange(newValue);
          }}
          aria-label="simple tabs example"
        >
          <Tab
            label={<Typography variant="h4">List</Typography>}
            {...a11yProps(0)}
          />
          <Tab
            label={
              <Typography variant="h4">
                {fromEdit ? "Edit" : "Create"}{" "}
              </Typography>
            }
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {/* <ResponsiveTable>{listChildren}</ResponsiveTable> */}
        {listChildren}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {addChildren}
      </TabPanel>
    </Fragment>
  );
}
